import { post, get } from '@/utils/request'

// 获取店铺列表
export function shopList(data) {
  return post('/admin/edu_youth_shop/shopList', data)
}

// 获取店铺详情
export function shopDetail(data) {
  return post('/admin/edu_youth_order/shopDetail', data)
}

// 店铺审核同意
export function shopApprove(data) {
  return post('/admin/edu_youth_order/shopApprove', data)
}

// 店铺审核拒绝
export function shopReject(data) {
  return post('/admin/edu_youth_shop/shopReject', data)
}

// 获取店铺详情（新接口）
export function detailMerchant(data) {
  return post('/admin/merchant/detailMerchant', data)
}

// 设置店铺轮播图
export function setBanners(data) {
  return post('/admin/merchant/setBanners', data)
}

// 获取设置列表
export function settingsList(data) {
  return post('/admin/edu_youth_shop/settingsList', data)
}

// 保存设置
export function settingsUpdate(data) {
  return post('/admin/edu_youth_shop/settingsUpdate', data)
}

// 删除店铺
export function delMerchant(data) {
  return post('/admin/merchant/delMerchant', data)
}

// 获取标签列表
export function getTagList(data) {
  return get('/admin/merchant/tagList', data)
}

// 添加标签
export function addTag(data) {
  return post('/admin/merchant/addTag', data)
}

// 编辑标签
export function updateTag(data) {
  return post('/admin/merchant/updateTag', data)
}

// 删除标签
export function deleteTag(data) {
  return post('/admin/merchant/deleteTag', data)
}
